import React from 'react';

export function compatStartTransition(callback: Function) {
  const hasStartTransition = typeof (React as any).startTransition === 'function';
  /*istanbul ignore if: cannot test in enzyme*/
  if (hasStartTransition) {
    (React as any).startTransition(callback);
  } else {
    callback();
  }
}
